<!-- Small/Medium viewport -->
<ul class="d-flex d-lg-none list-group" [ngClass]="{ 'shake' : showgrip }">
  <li class="list-group-item d-flex justify-content-between align-items-center subheader pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
        <strong>{{ 'Request.Person.Person' | translate }} {{index+1}}</strong>
    </div>
    <div class="col-9 col-md-10">
      <span class="float-end">
        <div class="btn-group">
          <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
          </button>
          <ul class="dropdown-menu">
            <li *ngIf="dossierPersonsAmount > 1 && sortingAllowed"><a class="dropdown-item pt-1 pb-1" (click)="EnablePersonChangeOrder(index+1, person.id)" translate>Button.ChangeOrder</a></li>
            <li><a class="dropdown-item pt-1 pb-1" (click)="EditPerson($event)" translate>Button.EditPerson</a></li>
            <li><a class="dropdown-item pt-1 pb-1" (click)="PersonRemoved()" translate>Button.Delete</a></li>
          </ul>
        </div>
      </span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.Person.Name</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{fullname}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.Person.EmailAddress</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{person.email}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.Person.Mobile</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{person.mobile}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.Person.Language</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span>{{person.language}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate">
      <span translate>Request.Person.IDMethod</span>
    </div>
    <div class="col-9 col-md-10 text-truncate">
      <span *ngIf="!person.validateRealIdentity && personHasNoIdentityProvider()" translate="ValidationMethod.Default"></span>
      <span *ngIf="!person.validateRealIdentity && personHasIdentityProvider()" translate="ValidationMethod.{{person.identityProvider}}"></span>
      <span *ngIf="person.validateRealIdentity" translate="ValidationMethod.iDIN"></span>
    </div>
  </li>
</ul>

<!-- Large viewport -->
<div class="row w-100 d-none d-lg-flex p-0 align-items-center person-row">
  <div class="col-1 firstcol text-truncate">{{ index + 1 }}</div>
  <div class="col-3 text-truncate">{{person.prefix ? person.firstname + " " + person.prefix + " " + person.lastname : person.firstname + " " + person.lastname}}</div>
  <div class="col-2 text-truncate">{{person.email}}</div>
  <div class="col-2 text-truncate">{{person.mobile}}</div>
  <div class="col-1 text-truncate">{{person.language | translate}}</div>
  <div class="col-2 text-truncate">
    <span *ngIf="!person.validateRealIdentity && personHasNoIdentityProvider()" translate="ValidationMethod.Default"></span>
    <span *ngIf="!person.validateRealIdentity && personHasIdentityProvider()" translate="ValidationMethod.{{person.identityProvider}}"></span>
    <span *ngIf="person.validateRealIdentity" translate="ValidationMethod.iDIN"></span>
  </div>
  <div class="col-1 text-end">
    <span class="float-end">
      <div class="float-end ms-2" *ngIf="sortingAllowed"><i class="bi bi-grip-vertical bi-large cursor-change-order"></i></div>
      <div class="btn-group">
        <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-three-dots bi-large"></i>
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item pt-1 pb-1" (click)="EditPerson($event)" translate>Button.EditPerson</a></li>
          <li><a class="dropdown-item pt-1 pb-1" (click)="PersonRemoved()" translate>Button.Delete</a></li>
        </ul>
      </div>
    </span>
  </div>
</div>